import { isNotDefined, sum, isTruthyString, isDefined, isFalsyString } from '@togglecorp/fujs';

function getMaximumFractionDigits(value) {
  if (value < 1000) {
    return 2;
  }
  const formatter = new Intl.NumberFormat('default', {
    notation: 'compact'
  });
  const formattedParts = formatter.formatToParts(value);
  const fraction = formattedParts.find(({
    type
  }) => type === 'fraction');
  if (isNotDefined(fraction) || isFalsyString(fraction.value)) {
    return 0;
  }
  if (Number(fraction.value) > 0.1) {
    return 1;
  }
  return 0;
}
function getNumberListSafe(list) {
  if (isNotDefined(list)) {
    return undefined;
  }
  const safeList = list.filter(isDefined);
  if (safeList.length === 0) {
    return undefined;
  }
  return safeList;
}
function sumSafe(list) {
  const safeList = getNumberListSafe(list);
  if (isNotDefined(safeList)) {
    return undefined;
  }
  return sum(safeList);
}
function maxSafe(list) {
  const safeList = getNumberListSafe(list);
  if (isNotDefined(safeList)) {
    return undefined;
  }
  return Math.max(...safeList);
}
function minSafe(list) {
  const safeList = getNumberListSafe(list);
  if (isNotDefined(safeList)) {
    return undefined;
  }
  return Math.min(...safeList);
}
function formatNumber(value, options) {
  if (isNotDefined(value)) {
    return undefined;
  }
  const formattingOptions = {};
  if (isNotDefined(options)) {
    formattingOptions.maximumFractionDigits = getMaximumFractionDigits(value);
    return new Intl.NumberFormat('default', formattingOptions).format(value);
  }
  const {
    currency,
    unit,
    maximumFractionDigits,
    compact,
    separatorHidden,
    language
  } = options;
  if (isTruthyString(unit)) {
    formattingOptions.unit = unit;
    formattingOptions.unitDisplay = 'short';
  }
  if (currency) {
    formattingOptions.currencyDisplay = 'narrowSymbol';
    formattingOptions.style = 'currency';
  }
  if (compact) {
    formattingOptions.notation = 'compact';
    formattingOptions.compactDisplay = 'short';
  }
  formattingOptions.useGrouping = !separatorHidden;
  if (isDefined(maximumFractionDigits)) {
    formattingOptions.maximumFractionDigits = maximumFractionDigits;
  } else {
    formattingOptions.maximumFractionDigits = getMaximumFractionDigits(value);
  }
  const newValue = new Intl.NumberFormat(language, formattingOptions).format(value);
  return newValue;
}
function incrementDate(date, days = 1) {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}
function getNumberOfDays(start, end) {
  const startDate = new Date(start);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(end);
  endDate.setHours(0, 0, 0, 0);
  let numDays = 0;
  for (let i = startDate; i < endDate; i = incrementDate(i)) {
    numDays += 1;
  }
  return numDays;
}
function getNumberOfMonths(start, end) {
  const monthDiff = Math.abs(12 * end.getFullYear() + end.getMonth() - (12 * start.getFullYear() + start.getMonth()));
  return monthDiff;
}

export { formatNumber, getNumberOfDays, getNumberOfMonths, incrementDate, maxSafe, minSafe, sumSafe };
//# sourceMappingURL=common.js.map
